module.exports = __webpack_public_path__ + "static/hospital_support_profile3@2x-c4c2abbf1a40b636cd98a5d5667ec90c.png";